import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import dayjs from 'dayjs';

import PayingMembersPageHeader from './components/PayingMembersPageHeader';
import PayingMembersTable from './components/PayingMembersTable';
import { SearchFilters } from './types';

const PayingMembers = (): JSX.Element => {
  const initialSearchFiltersValue: SearchFilters = {
    date: dayjs().endOf('day').toDate(),
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('firstName');

  return (
    <>
      <PayingMembersPageHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
      />

      <PayingMembersTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default PayingMembers;
